const Container = ({ children }) => (
  <div id="__next">
    <div className="css-1oteowz">{children}</div>
  </div>
);

export default Container;
